import script from "./IngredientsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./IngredientsList.vue?vue&type=script&setup=true&lang=ts"

import "./IngredientsList.vue?vue&type=style&index=0&id=33deb420&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33deb420"]])

export default __exports__